import script from "./ScrollList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollList.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollList.vue?vue&type=style&index=0&id=61ed900c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ed900c"]])

export default __exports__